import React from "react";
import styled from "styled-components";
import { Spinner, Table as BsTable } from "react-bootstrap";
import { ItemListadoProductos } from "../../../../services/productosServicios";
import { currencyFormat } from "../../../../utils/numberUtils";
import { DetalleProducto } from "../Model";

function Table({
  mascotas,
  onProductoCantidadChange,
  detallesPorProducto,
  isLoading,
  isSuccess,
}: {
  mascotas: ItemListadoProductos[];
  onProductoCantidadChange: (
    idProducto: string,
    nombre: string,
    cant: string,
    valor: number
  ) => void;
  detallesPorProducto: Map<string, DetalleProducto>;
  isLoading: boolean;
  isSuccess: boolean;
}) {
  return (
    <StyledTable responsive hover>
      <thead>
        <tr>
          <StyledColHeader>Producto</StyledColHeader>
          <StyledColHeader>Valor U</StyledColHeader>
          <StyledColHeader>Unidad</StyledColHeader>
          <StyledColHeader>Cantidad</StyledColHeader>
          <StyledColHeader>Descripción</StyledColHeader>
        </tr>
      </thead>
      <tbody>
        {isLoading && <LoadingItem />}
        {isSuccess &&
          mascotas.map((_) => (
            <TableItem
              key={_.id}
              producto={_}
              onCantidadChange={onProductoCantidadChange}
              value={detallesPorProducto.get(_.id)?.cantidad || 0}
            />
          ))}
      </tbody>
    </StyledTable>
  );
}

function TableItem({
  producto,
  onCantidadChange,
  value,
}: {
  producto: ItemListadoProductos;
  onCantidadChange: (
    idProducto: string,
    nombre: string,
    cant: string,
    valor: number
  ) => void;
  value: number;
}) {
  return (
    <StyledRow>
      <StyledCell className="col-3">{producto.nombre}</StyledCell>
      <StyledCell className="col-1">
        {currencyFormat(producto.precioUnitario)}
      </StyledCell>
      <StyledCell className="col-1">{producto.unidad}</StyledCell>
      <StyledCell className="col-1">
        <input
          onChange={(e) =>
            onCantidadChange(
              producto.id,
              producto.nombre,
              e.target.value,
              producto.precioUnitario
            )
          }
          type="number"
          className="form-control"
          value={value}
          min={0}
        />
      </StyledCell>
      <StyledCell className="col-4">{producto.descripcion}</StyledCell>
    </StyledRow>
  );
}

function LoadingCell() {
  return (
    <StyledCell>
      <Spinner animation={"border"} />
    </StyledCell>
  );
}

function LoadingItem() {
  return (
    <StyledRow>
      <LoadingCell />
      <LoadingCell />
      <LoadingCell />
      <LoadingCell />
    </StyledRow>
  );
}

const StyledTable = styled(BsTable)``;

const StyledCell = styled("td")``;

const StyledColHeader = styled("th")`
  color: ${(props) => props.theme.colors.main};
`;

const StyledRow = styled("tr")`
  cursor: pointer;
`;

export default Table;
